import { bootstrapApplication } from '@angular/platform-browser';
import { app } from '@microsoft/teams-js';

import { environment } from './environments/environment';

import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { Common } from 'app/modules/_common/service';
import { EnumAppMode } from 'app/modules/_common/types';

console.info("p", environment.isProduction);
console.info("v", environment.version);

const runApp = (appMode: EnumAppMode) => {
    console.info("a", EnumAppMode[appMode]);

    if (environment.version != localStorage.getItem('_v')) {
        localStorage._v = environment.version;

        // WARNING : DO NOT CHANGE WITHOUT INFORMING AUTHOR
        switch (true) {
            case window.location.pathname == '/start':
            case window.location.pathname == '/start/callback':
            case window.location.pathname == '/end':
            case window.location.pathname == '/start/callback':
                break;
            default:
                var v = Math.floor(100000 + Math.random() * 900000);
                //var v = environment.version;
                console.info('x', v);

                window.location.href = `${environment.base_uri}?v=${v}`;
        }
    }

    //alert(`set teams ${EnumAppMode[appMode]}`);
    Common.setAppMode(appMode);

    bootstrapApplication(AppComponent, appConfig).catch(e => console.error(e));
}

app.initialize().then(() => {
    app.getContext().then((context) => {
        runApp(EnumAppMode.Teams);

        // const hostClientType = context.app.host.clientType;
        // if (hostClientType != "web" && hostClientType != "desktop"){
        // }
    });
}, (e) => {
    runApp(EnumAppMode.NotTeams);

    //console.warn(e);
});
